import { Component, Input, OnInit } from '@angular/core';
import { CalendarEvent } from 'src/app/models/calendar-event';

@Component({
  selector: 'app-calendar-list-day',
  templateUrl: './calendar-list-day.component.html',
  styleUrls: ['./calendar-list-day.component.scss']
})
export class CalendarListDayComponent implements OnInit {

  /** The day as an ISO date (2026-10-13), as the grouped events are keyed. */
  @Input()
  day: string;

  @Input()
  events: Map<string, CalendarEvent[]>;

  constructor() { }

  ngOnInit(): void {
  }

}
